import React from 'react';
import SignatureManager from '../components/SignatureManager';

const Signatures = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Electronic Signatures</h1>
        <p className="text-gray-600 mt-2">
          Create and manage your electronic signature to sign rent receipts.
        </p>
      </div>
      
      <SignatureManager />
    </div>
  );
};

export default Signatures;